const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  save ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tp-trade-seller/save', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
